import * as types from '../constants';

export const setCheckinRequest = checkinRequestParams => ({
  type: types.SET_CHECKIN_REQUEST,
  payload: checkinRequestParams,
});